export const iconFontAwesomePoliticalDove = (
	<i className="fa-solid fa-dove"></i>
);
